import { useEffect } from 'react';

interface StructuredDataProps {
  type: 'service' | 'organization' | 'localbusiness' | 'event';
  data?: Record<string, any>;
}

const StructuredData: React.FC<StructuredDataProps> = ({ type, data }) => {
  useEffect(() => {
    // Remove existing structured data for this type
    const existingScript = document.querySelector(`script[data-structured-data="${type}"]`);
    if (existingScript) {
      existingScript.remove();
    }

    let structuredData;

    switch (type) {
      case 'organization':
        structuredData = {
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "أديم المناسبات",
          "alternateName": "Adim Events",
          "url": "https://adim-app.com",
          "logo": "https://adim-app.com/src/assets/logo.png",
          "description": "منصة خدمات المناسبات الأولى في السعودية - احجز جميع خدمات المناسبات من مكان واحد",
          "address": {
            "@type": "PostalAddress",
            "addressCountry": "SA",
            "addressRegion": "المملكة العربية السعودية"
          },
          "areaServed": {
            "@type": "Country",
            "name": "المملكة العربية السعودية"
          },
          "serviceType": [
            "خدمات المناسبات",
            "ضيافة",
            "تصوير",
            "تنسيق حفلات",
            "مكياج",
            "سامري",
            "عرضة سعودية",
            "كيترنق",
            "هير ستايل"
          ],
          "sameAs": [
            "https://twitter.com/adim_events",
            "https://instagram.com/adim_events",
            "https://linkedin.com/company/adim-events"
          ],
          ...data
        };
        break;

      case 'localbusiness':
        structuredData = {
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": "أديم المناسبات",
          "description": "منصة خدمات المناسبات الأولى في السعودية",
          "url": "https://adim-app.com",
          "telephone": "+966-XXX-XXXX",
          "priceRange": "$$",
          "address": {
            "@type": "PostalAddress",
            "addressCountry": "SA",
            "addressRegion": "الرياض"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 24.7136,
            "longitude": 46.6753
          },
          "openingHoursSpecification": [
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday"],
              "opens": "09:00",
              "closes": "18:00"
            }
          ],
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.8",
            "reviewCount": "150"
          },
          ...data
        };
        break;

      case 'service':
        structuredData = {
          "@context": "https://schema.org",
          "@type": "Service",
          "serviceType": "خدمات المناسبات",
          "provider": {
            "@type": "Organization",
            "name": "أديم المناسبات"
          },
          "areaServed": {
            "@type": "Country",
            "name": "المملكة العربية السعودية"
          },
          "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": "خدمات المناسبات",
            "itemListElement": [
              {
                "@type": "OfferCatalog",
                "name": "خدمات الضيافة",
                "itemListElement": [
                  {
                    "@type": "Offer",
                    "itemOffered": {
                      "@type": "Service",
                      "name": "ضيافة المناسبات",
                      "description": "خدمات ضيافة شاملة للمناسبات والأحداث"
                    }
                  }
                ]
              },
              {
                "@type": "OfferCatalog",
                "name": "خدمات التصوير",
                "itemListElement": [
                  {
                    "@type": "Offer",
                    "itemOffered": {
                      "@type": "Service",
                      "name": "تصوير المناسبات",
                      "description": "تصوير احترافي للمناسبات والأحداث"
                    }
                  }
                ]
              },
              {
                "@type": "OfferCatalog",
                "name": "خدمات التنسيق",
                "itemListElement": [
                  {
                    "@type": "Offer",
                    "itemOffered": {
                      "@type": "Service",
                      "name": "تنسيق الحفلات",
                      "description": "تنسيق وتنظيم الحفلات والمناسبات"
                    }
                  }
                ]
              }
            ]
          },
          ...data
        };
        break;

      case 'event':
        structuredData = {
          "@context": "https://schema.org",
          "@type": "EventSeries",
          "name": "خدمات أديم للمناسبات",
          "description": "سلسلة من الخدمات المتخصصة في تنظيم وإدارة المناسبات",
          "organizer": {
            "@type": "Organization",
            "name": "أديم المناسبات",
            "url": "https://adim-app.com"
          },
          "location": {
            "@type": "Country",
            "name": "المملكة العربية السعودية"
          },
          ...data
        };
        break;

      default:
        return;
    }

    // Create and append the script
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-structured-data', type);
    script.textContent = JSON.stringify(structuredData, null, 2);
    document.head.appendChild(script);

  }, [type, data]);

  return null;
};

export default StructuredData;
